import { reactive } from 'vue'

// Reactive state to hold dialog configuration and visibility
const dialogState = reactive({
	isVisible: false,
	title: '',
	message: '',
	mode: 'prompt', // 'prompt' or 'confirm'
	inputValue: '', // Only used for prompt mode
	resolvePromise: null, // Function to resolve the promise
})

// Function to reset state and hide the dialog
function resetDialog() {
	dialogState.isVisible = false
	dialogState.title = ''
	dialogState.message = ''
	dialogState.mode = 'prompt'
	dialogState.inputValue = ''
	dialogState.resolvePromise = null
}

// The globally callable async function for Yes/No confirmation
function showConfirm(title, message) {
	return new Promise((resolve) => {
		dialogState.title = title
		dialogState.message = message
		dialogState.mode = 'confirm'
		dialogState.inputValue = '' // Not used, but clear it
		dialogState.resolvePromise = resolve // Store the resolve function
		dialogState.isVisible = true
	})
}

// Optional: Function for the original prompt behavior (if needed globally)
function showPrompt(title, message, defaultValue = '') {
	return new Promise((resolve) => {
		dialogState.title = title
		dialogState.message = message
		dialogState.mode = 'prompt'
		dialogState.inputValue = defaultValue
		dialogState.resolvePromise = resolve // Store the resolve function
		dialogState.isVisible = true
	})
}

// Actions triggered by the dialog component
function handleConfirm(value) {
	if (dialogState.resolvePromise) {
		if (dialogState.mode === 'confirm') {
			dialogState.resolvePromise(true) // Resolve with true for Yes
		} else {
			dialogState.resolvePromise(value !== undefined ? value : dialogState.inputValue) // Resolve with input value for prompt
		}
	}
	resetDialog()
}

function handleCancel() {
	if (dialogState.resolvePromise) {
		if (dialogState.mode === 'confirm') {
			dialogState.resolvePromise(false) // Resolve with false for No
		} else {
			dialogState.resolvePromise(null) // Resolve with null for prompt cancellation
		}
	}
	resetDialog()
}

// Export the state and functions
export function promptModal() {
	return {
		dialogState,
		showConfirm,
		showPrompt, // Export if you want the global prompt function
		handleConfirm,
		handleCancel,
		resetDialog, // Potentially useful if manual reset is ever needed
	}
}
